export default __webpack_public_path__ + "bcfc3829fc50e45e99c961a557d6830a.png";